import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';
import { X, FileText, Loader } from 'lucide-react';
import { getConceptTranscript, getVideoTranscript } from '../services/studioApi';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

export default function TranscriptViewModal({ conceptId, videoId, conceptTitle, onClose }) {
  const { language } = useLanguage();
  const tStudent = translations[language]?.studio?.student || {};

  const [transcript, setTranscript] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const errorMsg = tStudent.transcriptNotAvailable || 'Transcript not available.';
    const fetcher = videoId
      ? getVideoTranscript(videoId)
      : getConceptTranscript(conceptId);
    fetcher
      .then(data => setTranscript(data.transcript_markdown || ''))
      .catch(() => setError(errorMsg))
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conceptId, videoId]);

  return (
    <div className="studio-modal-overlay" onClick={onClose}>
      <div
        className="studio-modal"
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: 680, width: '94vw', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}
      >
        {/* Header */}
        <div className="studio-modal-header" style={{ flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <FileText size={18} color="#5B35A0" />
            <h2 style={{ margin: 0, fontSize: '1rem' }}>
              {tStudent.transcript || 'Transcript'}
              {conceptTitle && <span style={{ color: '#888', fontWeight: 400, marginLeft: 6 }}>— {conceptTitle}</span>}
            </h2>
          </div>
          <button className="btn-icon" onClick={onClose}><X size={18} /></button>
        </div>

        {/* Body */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '1.25rem 1.5rem' }}>
          {loading && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#888', padding: '2rem 0' }}>
              <Loader size={16} style={{ animation: 'spin 1s linear infinite' }} />
              {tStudent.transcriptLoading || 'Loading transcript…'}
            </div>
          )}
          {error && (
            <p style={{ color: '#888', textAlign: 'center', padding: '2rem 0', fontSize: '0.9rem' }}>{error}</p>
          )}
          {!loading && !error && transcript && (
            <div className="transcript-view-body">
              <ReactMarkdown
                remarkPlugins={[remarkMath]}
                rehypePlugins={[rehypeKatex]}
              >
                {transcript}
              </ReactMarkdown>
            </div>
          )}
          {!loading && !error && !transcript && (
            <p style={{ color: '#aaa', textAlign: 'center', padding: '2rem 0', fontSize: '0.9rem' }}>
              {tStudent.transcriptNotAvailable || 'Transcript not available for this video.'}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
